import ContentModal from '../ContentModal';
import SimpleBar from 'simplebar-react';
import config from '../../../config';
import styled from 'styled-components';
import {useEffect, useState} from 'react';

export const SelectedLabel = styled.div`
  text-align: center;
  border: 1px solid #000000;
  border-radius: 2px;
  height: 44px;
  line-height: 42px;
  font-size: 14px;
  font-weight: bold;
  cursor: default;
  position: relative;
  background-color: transparent;
  transition: background-color 0.15s linear, color 0.15s linear;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  padding: 0 35px 0 20px;

  &::after {
    content: "";
    position: absolute;
    display: block;
    width: 11px;
    height: 8px;
    border-top: 2px solid #000000;
    border-bottom: 2px solid #000000;
    right: 15px;
    top: 50%;
    margin-top: -4px;
  }

  @media ${config.layout.wide} {
    &:hover {
      border: 1px solid #000000;
      background-color: #000000;
      color: #fff;

      &::after {
        border-color: #fff;
      }
    }
  }
`;

export default function SelectModal({
  title,
  candidates,
  selectedIndex,
  itemSelect,
  closeModal,
  modalIsOpen,
}) {
  const [uid, setUid] = useState(`s${Math.floor(Math.random() * 10000000)}`);

  useEffect(() => {
    if (modalIsOpen) {
      let elm = document.getElementById(`${uid}_${Math.max(0, selectedIndex)}`);
      if (elm && elm.scrollIntoView) {
        elm.scrollIntoView();
      }
    }
  }, [modalIsOpen]);

  return (
      <ContentModal closeModal={closeModal} isOpen={modalIsOpen}
                    selectmodal={1}>
        <div className="select-content">
          <div className="select-title">
            <span>{title}</span>
          </div>
          <SimpleBar autoHide={true} className="select-scroll-area">
            <div className={`scroll-content has-items`}>
              <table className="scroll-table">
                <tbody>
                {candidates.map((c, i) => {
                  return (
                      <tr
                          key={i}
                          id={`${uid}_${i}`}
                          className={`${selectedIndex == i ? 'selected' : ''}`}
                      >
                        <td
                            onClick={() => {
                              itemSelect(i);
                            }}

                            className={'in_touch_target'}
                        >
                          {c}
                        </td>
                      </tr>
                  );
                })}
                </tbody>
              </table>
            </div>
          </SimpleBar>
        </div>
      </ContentModal>
  );
}
